import { getGameStoreTimelineInfo } from '@/pages/opinion/services';
import { useEffect, useState } from 'react';
import { dealwithTimelineList } from '../utils';

export default function useGetGameStoreTimelineInfo({
  gameInfo,
  filter,
  type,
}: any) {
  const [trendLoading, setTrendLoading] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [mobileTrendsInfo, setMobileTrendsInfo] = useState<{
    lifetime: { [key: string | number]: Array<number | string> };
    selected: { [key: string | number]: Array<number | string> };
  }>({ lifetime: {}, selected: {} });

  useEffect(() => {
    if (!gameInfo || !filter) return;

    setTrendLoading(true);
    getGameStoreTimelineInfo({
      ...filter,
      ...gameInfo,
      channel: [type], // "app store"、 "google play"、"taptap"  对应不同tab
      channel_type: 'comments',
      types: ['lifetime', 'selected'],
      need_region: false,
    }).then((serverData: any) => {
      let { date_type } = filter;
      let { timeline_list, timeline_of_end_time, timeline_of_start_time } =
        serverData || {};
      const { data, nodata } = dealwithTimelineList(
        timeline_list || [],
        timeline_of_start_time,
        timeline_of_end_time,
        date_type,
      );
      setNodata(nodata);
      setMobileTrendsInfo(data);
      setTrendLoading(false);
    });
  }, [filter, type]);

  return {
    trendLoading,
    nodata,
    mobileTrendsInfo,
  };
}
